export enum FacilityType {
  Outdoor = 'Outdoor',
  Indoor = 'Indoor',
}
